import { render, staticRenderFns } from "./UploadBorderImg.vue?vue&type=template&id=1e394c20&scoped=true&"
import script from "./UploadBorderImg.vue?vue&type=script&lang=js&"
export * from "./UploadBorderImg.vue?vue&type=script&lang=js&"
import style0 from "./UploadBorderImg.vue?vue&type=style&index=0&id=1e394c20&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e394c20",
  null
  
)

export default component.exports